import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// トスアップフォーム - 質問一覧取得
export async function getTossUpFormOptions(id: string) {
  try {
    const path = "tossUpFormOptions";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// トスアップフォーム - 質問一覧編集
export async function putTossUpFormOptions(editData: { [key: string]: any }) {
  try {
    const path = "tossUpFormOptions";
    const bodys = editData;
    const response = await axios.put(CONST.apiUrl + path, {
      bodys,
    });
    return { edit: response.data.edit, warning: response.data.warning || "" };
  } catch (error) {
    // logout();
  }
}

// トスアップフォームフォーム詳細（メインテーブル） - 質問一覧取得
export async function getTossUpFormOption(id: string) {
  try {
    const path = "tossUpFormOption";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const detail_data: {
      [key: string]: number | string;
    } = response.data.detail_data[0];
    const option_data: {
      [key: string]: number | string;
    }[] = response.data.option_data;
    return { detail_data, option_data };
  } catch (error) {
    // logout();
    return { option_data: [] };
  }
}

// 質問一覧編集時の依存商材定義用商材一覧取得
export async function getTossUpFormOptionsDependProducts(category_id: string) {
  try {
    const path = "tossUpFormOptions/depend/products";
    const params = { category_id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const product_data: {
      high_rank_company_name: string;
      product_id: number;
      product_name: string;
    }[] = response.data.product_data;
    return {
      product_data,
    };
  } catch (error) {
    // logout();
    return {
      product_data: [],
    };
  }
}
